import ClientConfigurationService from './clientConfigurationService';

const sanitizeEventParams = (extraParams) => {
    var cleanedParams = {};

    if (!extraParams || typeof extraParams !== 'object') {
        return cleanedParams;
    }

    Object.keys(extraParams).forEach((key) => {
        var value = extraParams[key];

        if (typeof value === 'string') {
            value = value.trim();
        }

        if (value === undefined || value === null || value === '') {
            return;
        }

        cleanedParams[key] = value;
    });

    return cleanedParams;
}

const AnalyticsService = {
    sendEventWithClient: (eventName, extraParams = {}) => {
        ClientConfigurationService.getClientConfiguration2(true, null, (data) => {
            let clientName = 'Public';

            if (data && typeof data === 'object' && data.clientName) {
                clientName = data.clientName;
            }
            
            if (eventName && clientName && window.gtag) {
                window.gtag("event", eventName, {
                    client: clientName,
                    ...sanitizeEventParams(extraParams)
                });
            }
        });
    }
}

export default AnalyticsService;